import { gql } from '@apollo/client';
import React from 'react';
import Card, { CardSeparator } from '../components/Card';
import CardHeader from '../components/CardHeader';
import type { ActivityPostCard_PostFragment } from '../graphql/generated/graphqlTypes';
import PostBadge from '../post/PostBadge';
import PostPreview from '../post/PostPreview';
import PostTitleWithIcons from '../post/PostTitleWithIcons';
import PostSeriesMeta from '../post/series/PostSeriesMeta';
import postPath from '../utils/url/postPath';
import styles from './ActivityPostCard.module.scss';

const POST_FRAGMENT = gql`
  fragment ActivityPostCard_post on Post {
    series {
      ...PostSeriesMeta_series
    }
    ...postPath_post
    ...PostBadge_post
    ...PostPreview_post
    ...PostTitleWithIcons_post
  }
  ${postPath.fragments.post}
  ${PostBadge.fragments.post}
  ${PostPreview.fragments.post}
  ${PostSeriesMeta.fragments.series}
  ${PostTitleWithIcons.fragments.post}
`;

interface ActivityPostCardProps {
  post: ActivityPostCard_PostFragment;
  numLines?: number;
  charsPerLine?: number;
}

const ActivityPostCard = ({
  post,
  numLines,
  charsPerLine,
}: ActivityPostCardProps) => (
  <Card to={postPath(post)}>
    <CardHeader
      aboveTitle={
        post.series && (
          <div className={styles.seriesContainer}>
            <PostSeriesMeta series={post.series} postId={post.id} />
          </div>
        )
      }
      title={<PostTitleWithIcons post={post} />}
    />
    <CardSeparator />
    <PostPreview post={post} numLines={numLines} charsPerLine={charsPerLine} />
    <div className={styles.footer}>
      <PostBadge post={post} inline={false} />
    </div>
  </Card>
);

ActivityPostCard.fragments = {
  post: POST_FRAGMENT,
};

export default ActivityPostCard;
